import { render, staticRenderFns } from "./Pianos.vue?vue&type=template&id=9a7dc932&scoped=true"
import script from "./Pianos.vue?vue&type=script&lang=js"
export * from "./Pianos.vue?vue&type=script&lang=js"
import style0 from "./Pianos.vue?vue&type=style&index=0&id=9a7dc932&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a7dc932",
  null
  
)

export default component.exports